/**
 * Procedural SFX via Web Audio (no assets yet; produced SFX/music replace these through the same
 * API). Unlocked on the first user gesture; survives iOS interruptions by recreating the context.
 */
import { muted } from '../state/store';
let ctx: AudioContext | null = null; let master: GainNode | null = null;
export function unlockAudio(): void {
  try {
    if (!ctx) { ctx = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)(); master = ctx.createGain(); master.gain.value = 0.7; master.connect(ctx.destination); }
    if (ctx.state !== 'running') void ctx.resume();
  } catch { /* audio unavailable */ }
}
document.addEventListener('visibilitychange', () => { if (!document.hidden && ctx && ctx.state !== 'running') void ctx.resume().catch(() => { ctx = null; master = null; unlockAudio(); }); });
function tone(freq: number, dur: number, type: OscillatorType = 'sine', gain = 0.25, when = 0, slideTo?: number): void {
  if (!ctx || !master || muted.value) return;
  const o = ctx.createOscillator(); const g = ctx.createGain(); const t0 = ctx.currentTime + when;
  o.type = type; o.frequency.setValueAtTime(freq, t0); if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, t0 + dur);
  g.gain.setValueAtTime(0.0001, t0); g.gain.exponentialRampToValueAtTime(gain, t0 + 0.012); g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  o.connect(g); g.connect(master); o.start(t0); o.stop(t0 + dur + 0.02);
}
function noise(dur: number, gain = 0.2, when = 0): void {
  if (!ctx || !master || muted.value) return;
  const n = ctx.sampleRate * dur; const buf = ctx.createBuffer(1, n, ctx.sampleRate); const d = buf.getChannelData(0);
  for (let i = 0; i < n; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / n) ** 2;
  const s = ctx.createBufferSource(); s.buffer = buf; const g = ctx.createGain(); const t0 = ctx.currentTime + when;
  g.gain.setValueAtTime(gain, t0); g.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  const f = ctx.createBiquadFilter(); f.type = 'lowpass'; f.frequency.value = 1800;
  s.connect(f); f.connect(g); g.connect(master); s.start(t0);
}
export const sfx = {
  tap: () => tone(660, 0.07, 'triangle', 0.18),
  select: () => { tone(520, 0.08, 'triangle', 0.2); tone(780, 0.1, 'triangle', 0.16, 0.05); },
  lock: () => { tone(420, 0.12, 'square', 0.16); tone(840, 0.18, 'triangle', 0.22, 0.08); noise(0.12, 0.08, 0.02); },
  tick: () => tone(1200, 0.04, 'sine', 0.12),
  way: () => { tone(523, 0.12, 'triangle', 0.22); tone(784, 0.16, 'triangle', 0.2, 0.09); },
  noway: () => { tone(220, 0.35, 'sawtooth', 0.3, 0, 110); noise(0.5, 0.35, 0.05); tone(880, 0.5, 'triangle', 0.2, 0.15, 440); },
  fanfare: () => { [523, 659, 784, 1046].forEach((f, i) => tone(f, 0.22, 'triangle', 0.22, i * 0.11)); tone(1318, 0.5, 'triangle', 0.2, 0.46); },
  join: () => { tone(740, 0.1, 'triangle', 0.16); tone(988, 0.14, 'triangle', 0.14, 0.07); },
  drum: () => { tone(90, 0.2, 'sine', 0.5, 0, 45); noise(0.15, 0.25); },
};
